import { normalizeRedirect } from 'auth-common/shared';
import type { AuthInfo } from '../hook/model/authInfo';
import { route } from '../router';

export const findOrganizationByProjectId = (organizations: AuthInfo.Organization[], projectId: string) =>
  organizations.find((organization) => organization.projects.some((project) => project.id === projectId));

export const isSamlEnforcementSatisfiedForProject = (organizations: AuthInfo.Organization[], projectId: string): boolean => {
  const organization = findOrganizationByProjectId(organizations, projectId);
  const project = organization?.projects.find((p) => p.id === projectId);
  return !(project?.authRequirements.sso.required && !project.authRequirements.sso.satisfied);
};

export const getSamlRequiredUrl = (params: { organizationId: string; redirect?: string | undefined }): string => {
  const query: Record<string, string> = { org: params.organizationId };
  const normalizedRedirect = normalizeRedirect(params.redirect);
  if (normalizedRedirect) {
    query.redirect = normalizedRedirect;
  }
  return route('/saml-required', { query });
};

export const redirectToSamlRequired = (params: { organizationId: string; redirect?: string | undefined }): void => {
  if (typeof window === 'undefined') return;
  window.location.href = getSamlRequiredUrl(params);
};

export const resolveOrganizationIdForSamlRedirect = (params: {
  organizations: AuthInfo.Organization[];
  projectId?: string | undefined;
  organizationId?: string | undefined;
}): string | undefined => {
  if (params.organizationId) return params.organizationId;
  if (!params.projectId) return undefined;
  return findOrganizationByProjectId(params.organizations, params.projectId)?.id;
};
